'use es6';

import { cloneNormalizedLayoutData } from 'DesignData/lib/normalization/layouts/utils';
import { LayoutWidget } from 'DesignData/models/layouts';
import Widget from 'DesignData/models/widgets/Widget';
/**
 * If a layout has widgets with duplicate ids, returns a
 * new normalized layout with corrected ids.
 *
 * @param {NormalizedLayoutData} normalizedLayoutData
 * @returns {NormalizedLayoutData}
 * @see {@link https://issues.hubspotcentral.com/browse/CG-10835}
 */

export function fixNonUniqueWidgetIds(normalizedLayoutData) {
  const widgetIds = {};
  const dupes = []; // Look for dupes

  {
    const {
      rows
    } = normalizedLayoutData;
    Object.keys(rows).forEach(rowId => {
      const row = rows[rowId];

      for (const [index, widgetId] of row.entries()) {
        if (widgetIds[widgetId]) {
          dupes.push({
            rowId,
            widgetId,
            index
          });
        } else {
          widgetIds[widgetId] = true;
        }
      }
    });
  }

  if (dupes.length === 0) {
    return normalizedLayoutData;
  } // Create new data and replace dupes


  const data = cloneNormalizedLayoutData(normalizedLayoutData);
  {
    const {
      rows,
      widgets
    } = data;

    for (const {
      rowId,
      widgetId,
      index
    } of dupes) {
      const widget = widgets[widgetId];
      const row = rows[rowId];
      const id = Widget.generateWidgetName();
      const newWidget = new LayoutWidget(Object.assign({}, widget, {
        id,
        name: id
      }));
      widgets[id] = newWidget;
      rows[rowId] = [...row.slice(0, index), id, ...row.slice(index + 1)];
    }
  }
  return data;
}